// ANGULAR MODULES
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// CUSTOM AND THIRD PARTY MODULES
import { MainLayoutRoutingModule } from './main-layout-routing.module';
import { SharedModule } from '@shared/shared/shared.module';
import { MaterialModule } from '@shared/material/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';

// COMPONENTS
import { MainLayoutComponent } from './main-layout.component';

// OTHERS
import { httpInterceptorProviders } from '@app-core/interceptors';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { LayoutComponent } from './components/layout/layout.component';
import { CookieService } from 'ngx-cookie-service';
import { SidebarTopComponent } from './components/sidebar-top/sidebar-top.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    MainLayoutComponent,
    SidenavComponent,
    LayoutComponent,
    SidebarTopComponent,
    TopBarComponent,
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MainLayoutRoutingModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
  ],
  providers: [httpInterceptorProviders, CookieService],
})
export class MainLayoutModule {}
